import axios from "axios";
var base64 = require('base-64');

var userId = null;

function getauth(userId) {
    userId = userId ? userId : (JSON.parse(JSON.parse(localStorage['persist:root']).admin).authData.userId ? JSON.parse(JSON.parse(localStorage['persist:root']).admin).authData.userId : null);
    var authorization_value = null;
    if (userId)
        authorization_value = "Basic " + base64.encode(encodePassword(userId) + ":");
    return authorization_value;
}

const instance = axios.create({
    // baseURL: 'http://localhost:5000/',
    headers: { 
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Headers': '*',
    },
});

/**
 * Actions 
 *
 * 
 
*/
export function resetTool(actual_data) {
    return function(dispatch){
        dispatch({
            type: "RESET_TOOLS",
            payload: actual_data
        })
    }
}

export function setDashboardConfig(actual_data) {
    return function(dispatch){
        dispatch({
            type: "DASHBOARD_CONFIG",
            payload: actual_data
        })
    }
}

export function setData(final_data) {
    return function(dispatch){
        dispatch({
            type: "SET_TOOLS",
            payload: final_data
        })
    }
    // return function (dispatch) {
    //     // '/initialData?siteId=' + req.query.siteId + '&toolId=' + req.query.toolId + "&filterType=all&propValues=&filterValues=&type=&chartType=" + req.query.chart
    //     instance.get('/app/initialRequest', {
    //         headers: {
    //             Authorization: getauth(authData.userId)
    //         },
    //         params: {
    //             siteId: actual_data.siteId, toolId: actual_data.toolId, filterType: 'all',
    //             propValues: null, filterValues: null, type: null, userId: userId
    //         }
    //     }).then(res => {
    //         var userFeature = res.data.userFeature;
    //         var dateObject = res.data.dateTime[0];
    //         var final_data = {
    //             endDate: dateObject.dashboardEndTime,
    //             startDate: dateObject.dashboardStartTime,
    //             endTime: dateObject.endTime,
    //             startTime: dateObject.startTime,
    //             userFeature: userFeature,
    //             dashbordGroups: res.data.dashbordGroups,
    //             userDBSetting: res.data.userDBSetting,
    //             summarizationDetails: res.data.summarizationDetails,
    //             getAllUsers: res.data.getAllUsers,
    //             getNotification: res.data.getNotification,
    //             getuserprofile: res.data.getuserprofile,
    //             chartDefault: res.data.chartDefault,
    //             alfred: {intent : res.data.intent, metric: res.data.metric, property: res.data.property, questions: res.data.questions, location: res.data.location, chart_array: res.data.chart},
    //             ...actual_data
    //         }
            
    //     })
    // }
};

export function setAuthData(data) {
    return {
        type: "SET_AUTH_STORE",
        payload: data
    }
};



export function removeData() {
    return {
        type: "REMOVE_DATA",
    }
};

export function set_property_metric_breakup(data) {
    return {
        type: "set_property_metric_breakup",
        payload: data
    }
};

export function setDrillHandle(data) {
    return {
        type: "setDrillHandle",
        payload: data
    }
};

export function setInsightFunction(data) {
    return {
        type: "setInsightFunction",
        payload: data
    }
};

export function enablePageDescription(data) {
    return {
        type: "enablePageDescription",
        payload: data
    }
};

export function disablePageDescription(data) {
    return {
        type: "disablePageDescription",
        payload: data
    }
};

export function handle_retain_filter_flag() {
    return {
        type: "handle_retain_filter_flag",
        payload: data
    }
}

export function handle_transpose_table(data) {
    return {
        type: "handle_transpose_table",
        payload: data
    }
}

export function handle_dataLabel_Overlap(data) {
    return {
        type: "handle_dataLabel_Overlap",
        payload: data
    }
}

export function handle_restricted_Filter(data) {
    return {
        type: "handle_restricted_Filter",
        payload: data
    }
}

export function setMetricRange(data) {
    return {
        type: "setMetricRange",
        payload: data
    }
}

export function handle_compare(data) {
    return {
        type: "handle_compare",
        payload: data
    }
}

export function handle_quadrant(data) {
    return {
        type: "handle_quadrant",
        payload: data
    }
}

export function get_property_metric_breakup() {
    return {
        type: "get_property_metric_breakup"
    }
};

export function remove_property_metric_breakup() {
    return {
        type: "remove_property_metric_breakup",
    }
};

export function setFilter() {
    return {
        type: "SET_FILTER",
    }
};

export function removeFilter() {
    return {
        type: "REMOVE_FILTER",
    }
};

export function setDashboardId(data) {
    return {
        type: "set_dashboard_id",
        payload: data
    }
};

export function setKpiColumnConfig(data) {
    return {
        type: "set_kpi_column_config",
        payload: data
    }
};

export function dataLabelConfig(data) {
    return {
        type: "datalabel_config",
        payload: data
    }
};

export function setDatasetChange(data) {
    return {
        type: "set_dataset_change",
        payload: data
    }
};

export function setDashboardComponent(data) {
    return function (dispatch) {
        // '/initialData?siteId=' + req.query.siteId + '&toolId=' + req.query.toolId + "&filterType=all&propValues=&filterValues=&type=&chartType=" + req.query.chart
        instance.get('/app/getDashboardComponent', {
            headers: {
                Authorization: getauth(data.userId),
                'sessionId': encodePassword(data.sessionId)
            },
            params: {
                siteId: data.siteId, toolId: data.toolId
            }
        }).then(res => {
            res.data = decodeResponseBody(res.data)
            var final_data = {
                dashbordGroups: res.data.dashbordGroups,                
                dashboardGroupsName: res.data.dashboardGroupsName,
            }
            dispatch({
                type: "set_dashboard_component",
                payload: final_data
            })
        })
    }    
};

export function setTableActions(data) {
    return {
        type: "setTableActions",
        payload: data
    }
};

export function setCookie() {
    return {
        type: "SET_COOKIE",
        payload: 'some Value'
    }
};
export function removeCookie() {
    return {
        type: "REMOVE_COOKIE",
    }
};
export function getToolsData(actual_data) {
    return function(dispatch){
        dispatch({
            type: "GET_TOOLS_DATA",
            payload: actual_data
        })
    }
}
export function getGlobalFilters(data) {
    return function (dispatch) {
        instance.get('/app/getGlobalFilter', {
            headers: {
                Authorization: getauth(data.userId),
                'sessionId': encodePassword(data.sessionId)
            },
            params: { siteId: data.siteId, toolId: data.toolId }
        }).then(res => {
            res.data = decodeResponseBody(res.data)
            dispatch({
                type: "SET_GLOBAL_FILTERS",
                payload: {
                    temp_filters: res.data.value[0] && res.data.value[0].temporary_filter && isJson(res.data.value[0].temporary_filter) ? JSON.parse(res.data.value[0].temporary_filter) : []
                }
            })
        })
    }
}
export function setGlobalFilters(data) {
    return {
        type: "SET_GLOBAL_FILTERS",
        payload: {
            temp_filters: data
        }
    }
}
export function getData(dataSetResult, authData) {
    return function (dispatch) {
        instance.get('/app/tools', {
            headers: {
                Authorization: getauth(authData.userId),
                'sessionId': encodePassword(authData.sessionId)
            },
            params: {
                siteId: authData.siteId,
                type: "dashboard"
            }
        }).then(res => {
            res.data = decodeResponseBody(res.data)
            dispatch({
                type: "GET_TOOLS",
                payload: {
                    datasets: res.data.value,
                    allDashboards: res.data.dashboardData,
                    allMetric: res.data.metric,  
                    allProperty: res.data.property,
                    allDBSettingsData: res.data.dbSettingsData,
                    metricFunction: res.data.metricFunction,
                    dashboardCustomInfo: res.data.information
                }
            })
            /* if(JSON.stringify(dataSetResult)!==JSON.stringify(res.data.value)){
                dispatch({
                    type: "GET_TOOLS",
                    payload: {
                        datasets: res.data.value,
                        dashboards: res.data.dashboardData    
                    }
                })
            } */
        })
    }
};
export function resetAlfredQuestions() {
    return function(dispatch){
        dispatch({
            type: "RESET_ALFRED_QUESTIONS"
        })
    }
};
export function getAlfredQuestions(dataSet, authData) {
    return function (dispatch) {
        instance.get('/app/metric', {
            headers: {
                Authorization: getauth(authData.userId),
                'sessionId': encodePassword(authData.sessionId)
            },
            params: {
                siteId: dataSet.siteId,
                toolId: dataSet.toolId
            }
        }).then(res => {
            dispatch({
                type: "GET_ALFRED_QUESTIONS",
                payload: decodeResponseBody(res['data'])
            })
        })
    }
};
export function getDataSet(dataSet) {
    return function (dispatch) {
        instance.get('/api/data', {
            headers: {
                Authorization: getauth()
            },
            params: {
                siteId: dataSet.siteId,
                toolId: dataSet.toolId
            }
        }).then(res => {
            dispatch({
                type: "GET_DATA",
                payload: decodeResponseBody(res['data'])
            })
        }).catch(err => {
            dispatch({
                type: "GET_DATA",
                payload: []
            })
        })
    }
};
export function getInitialData(dataSet, chart, authData) {
    // $this->_rmApiURL . 'initialData?siteId=' . $this->_siteId . "&toolId=" . $this->_toolId."&filterType=all&propValues=".rawurlencode($property)."&filterValues=".rawurlencode($filter)."&include=".rawurlencode($include)."&exclude=".rawurlencode($exclude)."&chartType=".rawurlencode($chartType)."&type=".$dispType;
    return function (dispatch) {
        instance.get('/app/initialData', {
            headers: {
                Authorization: getauth(authData.userId),
                'sessionId': encodePassword(authData.sessionId)
            },
            params: {
                siteId: dataSet.siteId, toolId: dataSet.toolId,
                chartType: chart
            }
        }).then(res => {
            res = decodeResponseBody(res['data'])
            // res.data = { ...res.data, "chart": chart };
            res = { ...res, "chart": chart };
            dispatch({
                type: "GET_INITIAL_DATA",
                payload: res
            })
        }).catch(err => {
            dispatch({
                type: "GET_INITIAL_DATA",
                payload: []
            })
        })
    }
};

export function setChartType(data) {
    return {
        type: "SET_CHART_TYPE",
        payload: data
    }
};

export function setQuestion(data) {
    return {
        type: "SET_QUESTION_STATE",
        payload: data
    }
}
export function setChartQuestion(data) {
    return {
        type: "set_chart_alfred",
        payload: data
    }
}

export function getQuestion() {
    return {
        type: "GET_QUESTION_STATE"
    }
}

export function setSummary(data){
    return {
        type: "GET_DATA",
        payload: data
    }
}

export function saveFilterToggleHandle(data) {
    return {
        type: "FILTER_TOGGLE",
        payload: data
    }
}

export function set_initial_values_url(data) {
    return {
        type: "set_initial_values_url",
        payload: data
    }
}

export function set_start_end_date(data) {
    return {
        type: "set_start_end_date",
        payload: data
    }
}

export function set_disp_objects(data) {
    return {
        type: "set_disp_objects",
        payload: data
    }
}

export function setAuthObj(data) {
    return {
        type: "set_auth_obj",
        payload: data
    }
}

export function toggleOldFilter(data) {
    return {
        type: "FILTER_OLD_TOGGLE",
    }
}

export function setTVMode(data) {
    return {
        type: "TV_MODE",
        payload: data
    }
}

export function setUserList(data) {
    return {
        type: "USER_LIST",
        payload: data
    }
}


export function setTab(data){
    return function(dispatch){
        dispatch({
            type:"SET_TAB",
            payload:data
        })
    }
}

export function setConnectionType(data) {
    return {
        type: "SET_CONNECTION_TYPE",
        payload: data
    }
}

export function setRequestId(data) {
    return {
        type: "SET_REQUEST_ID",
        payload: data
    }
}

export function storeRequestState(data) {
    return {
        type: "SET_REQUEST_STATE",
        payload: data
    }
}
